import { loadSia } from "../../api/envresources/sia.api";
import { loadSiaEvolution } from "../../api/envresources/evolution.api";
import { loadClasses } from "../../api/envresources/classes.api";
import {loadLandUseOverview} from "../../api/envresources/overview";
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
  classes: [],
  sia: {},
  evolution: [],
  landUseOverview: []
};

const mutations = {
  setClasses(state, data){
    state.classes = data ? data : [];
  },
  setSia(state, data){
    state.sia = data ? data : {};
  },
  setSiaEvolution(state, data){
    state.evolution = data ? data : [];
  },
  setLandUseOverview(state, data){
    state.landUseOverview = data ? data : [];
  },
};

const actions = {
  async loadClasses( {commit}){
    try{
      const response = await loadClasses();
      commit('setClasses', response.data);
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as classes.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setClasses', undefined);
    }
  },
  async loadSia( {commit}, payload ){
    const {locacronymn} = payload;
    try{
      const response = await loadSia(locacronymn);
      commit('setSia', response.data)
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do SIA.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSia', undefined)
    }
  },
  async loadSiaEvolution( {commit}, payload ){
    const {locacronymn} = payload;
    try{
      const response = await loadSiaEvolution(locacronymn);
      commit('setSiaEvolution', response.data)
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações de evolução do SIA.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSiaEvolution', undefined)
    }
  },
  async loadLandUseOverview( {commit}, payload ){
    const {locacronymn} = payload;
    try{
      const response = await loadLandUseOverview(locacronymn);
      commit('setLandUseOverview', response.data)
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações de uso da terra.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setLandUseOverview', undefined)
    }
  },
};

const getters = {
  sia: (state) => state.sia,
  evolution: (state) => state.evolution,
  classes: (state) => state.classes,
  landUseOverview: (state) => state.landUseOverview,
};
export default {
  state,
  mutations,
  actions,
  getters
}
